export enum ThumbnailResponseType {
    Blob,
    Url,
}
import { loadFFmpeg } from '@/services/video/ffmpgetInstance';
import { fetchFile } from '@ffmpeg/util';
import { v4 as uuidv4 } from 'uuid';
import { ffmpegInstance } from '../services/video/ffmpgetInstance';

const jpegImageMimeType = 'image/jpeg';

const captureThumbnail = async (fileUrl: string, responseType: ThumbnailResponseType): Promise<string | Blob> => {
    await loadFFmpeg();

    const videoFileName = `${uuidv4()}_input_video.mp4`;
    const outputFileName = `${uuidv4()}_thumbnail_frame.jpg`;
    await ffmpegInstance.writeFile(videoFileName, await fetchFile(fileUrl));
    await ffmpegInstance.exec(['-y', '-i', videoFileName, '-vf', "select='eq(n,1)'", '-vframes', '1', outputFileName]);
    const frameBuffer = await ffmpegInstance.readFile(outputFileName);

    switch (responseType) {
        case ThumbnailResponseType.Url:
            const blob = new Blob([frameBuffer as BlobPart], { type: jpegImageMimeType });
            return await new Promise<string>((resolve, reject) => {
                const reader = new FileReader();
                reader.onloadend = () => {
                    if (reader.result) {
                        resolve(reader.result as string);
                    } else {
                        reject(new Error('Failed to create data URL from thumbnail.'));
                    }
                };
                reader.onerror = () => {
                    reject(new Error('Error reading thumbnail blob as data URL.'));
                };
                reader.readAsDataURL(blob);
            });
        case ThumbnailResponseType.Blob:
            return new Blob([frameBuffer as BlobPart], { type: jpegImageMimeType });
        default:
            throw new Error('Unsupported responseType');
    }
};

const createThumbnail = async (file: File, responseType: ThumbnailResponseType = ThumbnailResponseType.Url): Promise<string | Blob> => {
    return new Promise((resolve, reject) => {
        const fileUrl = URL.createObjectURL(file);
        const video = document.createElement('video');
        video.src = fileUrl;
        video.onloadedmetadata = () => {
            video.currentTime = 0.01;
        };
        video.onseeked = async () => {
            try {
                const thumbnail = await captureThumbnail(fileUrl, responseType);
                resolve(thumbnail);
            } catch (error) {
                reject(error);
            }
        };

        video.onerror = reject;
    });
};

export default createThumbnail;
